const getNgRelatedKeyword = () => {
  const h_arr = ['セルビア人',
    'スペイン人',
    'ウクライナ人',
    'フィリピン人',
    'スロベニア人',
    'インド人',
    'パキスタン人',
    'ドイツ人',
    'アメリカ人',
    'ヨーロッパ人',
    '台湾人',
    '外国人',
    'サーミ人',
    '日本人',
    'ロシア人',
    'ベトナム人',
    'アイマラ人',
    'イタリア人',
    'アステカ人',
    'アジア人']

  const n_arr = ['10歳',
    '10才',
    '10代',
    '20代',
    '20才',
    '20歳',
    '30歳',
    '30代',
    '40歳',
    '40代',
    '50歳',
    '50代',
    '60歳',
    '60代',
    '70歳',
    '70代',
    '80代']

  return h_arr.concat(n_arr)
}

export const setSearchRelatedTag = (kw_arr, title, service = 'photo') =>	{
  let buf = ''
  let kw_related = kw_arr
  let kw_related_ng: any[] = []
  let maxtagcnt = 4
  let tagcnt = 0

  switch (service) {
  case 'photo':
    break

  case 'illust':
    kw_related_ng = getNgRelatedKeyword()
    maxtagcnt = 2
    break

  case 'slh':
    kw_related_ng = getNgRelatedKeyword()
    maxtagcnt = 2
    break

  case 'all':
    kw_related_ng = getNgRelatedKeyword()
    maxtagcnt = kw_related.length
    break
  }

  for (const k in kw_related) {
    const v = kw_related[k]
    if (kw_related_ng.length >= 1) {
      const idx = kw_related_ng.findIndex(kw => kw === v)
      if (idx !== -1) continue
    }

    if (title && v && title.indexOf(v) >= 0) {
      if (buf !== '') buf += ' '
      buf += v
      delete kw_related[k]
    }
  }

  kw_related = kw_related.filter(kw => !!kw)

  const arr = buf !== '' ? [...buf, ...kw_related] : kw_related

  buf = ''
  for (let i = 0; i < arr.length; i++) {
    if (kw_related_ng.length >= 1) {
      const idx = kw_related_ng.findIndex(kw => kw === arr[i])
      if (idx !== -1) continue
    }

    if (tagcnt >= maxtagcnt) break
    if (buf !== '') buf += ' '
    buf += arr[i]
    tagcnt++
  }

  return buf.replace(/\s+/g, '')
}
